import {FormLayout} from "@t/fd/layout/FormLayout.ts";
import type {ArrayAddButton} from "@t/fd/layout/Array.ts";
import {AgendaPart, DataColumn, DataGetterRule} from "@t/fd/layout/Agenda.ts";
import type {View} from "@t/agenda/View.ts";
import type {FormPartOrReference} from "../FormPartOrReference";

/**
 * Properties which are share by both agenda and items
 */
export interface ItemsGrid extends FormLayout {
	sorting: "no" | "yes" | "manual";  // sorting mode yes=clicking on the column, manul=by dragging
	orderProperty?: string; // ordering state (integer) is saved directly to this item property (only for manual sorting)

	selectable?: boolean;    // user can select rows for batch operations
	selectMax?: number;    // maximum number of rows that can be selected
	selectionProperty?: string;     // selection state (boolean) is saved directly to this item property (if missing, selected rows are kept internally without data modification)
	collapse?: boolean;			// if true horizontal available space is measured and normal (see LayoutMode) columns can be collapsed into multiple runs
	deletable?: boolean;		// adds delete icon to support deletion of individual items (note: you can support batch deletion by select+batch op)

	add?: ArrayAddButton[];

	/** Form to edit items */
	item: FormPartOrReference;

	/**
	 * How to obtain unique row identity from the row object.
	 * This is required to allow selectable rows.
	 * Value obtained by these getters will be stored to $id variable
	 **/
	identity?: DataGetterRule[];

	/** All available columns */
	columns: DataColumn[];
	/** Defines column layout, filtering and sorting */
	view: View;

}

export interface Items extends ItemsGrid {
	type: "items";
}

export function isAgenda(grid:ItemsGrid):grid is AgendaPart {
	return grid?.type === "agenda";
}

export function isItems(grid:ItemsGrid):grid is Items {
	return grid?.type === "items";
}